import React from 'react';
import { useHistory } from 'react-router-dom';

// @material-ui/core
import Button from '@material-ui/core/Button';
import { Icon, IconButton } from '@material-ui/core';
import BookmarkBorderIcon from '@material-ui/icons/BookmarkBorder';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import { Mixpanel } from '../../../../../../shared/components/Mixpanel/mixpanel';

// redux
import { connect } from "react-redux"

import { CourseService,MIXPANEL_EVENT } from '@sdk-point/talisis';
import clsx from 'clsx';
const courseService = new CourseService(process.env.REACT_APP_ENV, process.env.REACT_APP_X_API_KEY);

const SaveUnsaveButton = (props) => {
    const { course, classes, user, white, icon_button, fontSize=24 } = props;
    const [updatingStatus, setUpdatingStatus] = React.useState(false);
    const [saveStatus, setSaveStatus] = React.useState(false);

    const handleSaveUnsaveCourse = async (e) => {
        e.preventDefault();
        e.persist();
        setUpdatingStatus(true);
        let newStatus = !saveStatus;
        setSaveStatus(newStatus);
        const response = await courseService.saveUnsaveCourse(user.person_id, course.id, newStatus);
        if(response.response.length > 0){

            let companyMixpanel =  course?.company_id != null ? course?.company_id : course?.source_name;
            const role = JSON.parse(localStorage.getItem('permissions'));
           

            setSaveStatus(response.response[0].is_active);
            setUpdatingStatus(false);
        }
        e.stopPropagation()
    };

    const getData = async () => {
        if(course.is_favorited != null){
            setSaveStatus(course.is_favorited);
        }
    }

    React.useEffect(() => {
        getData();
    }, []);

    return (
        icon_button===undefined
        ?
            <Button variant="contained" color='primary' className={classes} disabled={updatingStatus} onClick={(e) => handleSaveUnsaveCourse(e) }>{ saveStatus ? <BookmarkIcon color={white?"white":"primary"}/> : <BookmarkBorderIcon color={white?"white":"primary"}/>}</Button>
        :
            <IconButton color='secondary' className={classes} style={{ border:'none' }} disabled={updatingStatus} onClick={(e) => handleSaveUnsaveCourse(e) }>
                { saveStatus ? <Icon className={clsx('ri-bookmark-fill', `font-size-${fontSize}`)} color={white?"white":"primary"}/> : <Icon className={clsx('ri-bookmark-line', `font-size-${fontSize}`)} color={white?"white":"primary"}/>}
            </IconButton>
    );
};

const mapStateToProps = (reducers) => reducers.userReducer;

export default connect(mapStateToProps, {})(SaveUnsaveButton);